import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import App from './App';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Prevent Google Translate from mutating the DOM and breaking React reconciliation
document.documentElement.setAttribute('translate', 'no');
document.documentElement.classList.add('notranslate');

// Kiosk mode detection — skip StrictMode double-renders and SW prompts for production kiosks
const isKiosk = typeof window !== 'undefined' && (
  window.location.hostname.includes('.checkin.') ||
  new URLSearchParams(window.location.search).get('kiosk') === 'true'
);

const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(
  isKiosk ? (
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  ) : (
    <React.StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </React.StrictMode>
  )
);

// Register Service Worker for PWA functionality (skip in kiosk mode — no update prompts needed)
if (!isKiosk) {
  serviceWorkerRegistration.register({
    onSuccess: () => {
    },
    onUpdate: (registration) => {
      
      // In standalone mode, automatically update without prompting
      // This ensures the PWA stays up to date
      if (serviceWorkerRegistration.isPwa()) {
        if (registration.waiting) {
          registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        }
        return;
      }
      
      // In browser mode, show a toast-style update banner
      const banner = document.createElement('div');
      banner.innerHTML = `
        <div style="position:fixed;bottom:16px;right:16px;z-index:9999;background:#2563eb;color:white;padding:12px 20px;border-radius:8px;box-shadow:0 4px 12px rgba(0,0,0,0.15);font-family:system-ui;display:flex;align-items:center;gap:12px;">
          <span>A new version is available.</span>
          <button id="update-refresh-btn" style="background:white;color:#2563eb;border:none;padding:6px 16px;border-radius:6px;font-weight:600;cursor:pointer;font-size:14px;">Refresh</button>
          <button id="update-dismiss-btn" style="background:transparent;color:white;border:1px solid rgba(255,255,255,0.5);padding:6px 12px;border-radius:6px;cursor:pointer;font-size:14px;">Later</button>
        </div>
      `;
      document.body.appendChild(banner);
      document.getElementById('update-refresh-btn')?.addEventListener('click', () => {
        if (registration.waiting) {
          registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        }
        window.location.reload();
      });
      document.getElementById('update-dismiss-btn')?.addEventListener('click', () => {
        banner.remove();
      });
    },
    onManifestChange: () => {
      // The actual reload is handled in serviceWorkerRegistration.ts
    }
  });
}
